export default __webpack_public_path__ + "static/media/Tennis_09.05b5687b.png";